import { AppName } from 'root-constants'
import { TAppName } from 'root-types'

/**
 * Facebook Pixel IDs used only for backend event tracking.
 *
 * Any client-side usage will permanently invalidate the pixel and make it unusable for future tracking.
 */
export const BACKEND_ONLY_FACEBOOK_PIXEL_IDS = [
  '698695419436143',
  '1696019381283141',
  '1116233830564602',
  '965254702394047',
  '1637715974303923',
  '1410978537258500',
  '1246111284235465',
  '900983862717397',
  '1696222799130873',
]

export const CLARITY_PROJECT_IDS: Record<TAppName, string | undefined> = {
  [AppName.blessedPath]: process.env.BLESSEDPATH_CLARITY_PROJECT_ID,
  [AppName.ayahPath]: process.env.AYAHPATH_CLARITY_PROJECT_ID,
  [AppName.karmaPath]: process.env.KARMAPATH_CLARITY_PROJECT_ID,
}
